import { Link } from "react-router-dom";
import { ReactComponent as Error404 } from "./Error404.svg";
import styled from "styled-components";
import { rootFixedColor } from "styles/theme";

const ErrorContainer = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    svg {
        width: 300px;
        height: 300px;
    }
    font-size: 1.25rem;
    a:hover {
        color: ${rootFixedColor.accentColor};
    }
`;

function Error() {
    return (
        <ErrorContainer>
            <Error404 />
            <Link to={"/admin"}>메인으로 이동</Link>
        </ErrorContainer>
    );
}

export default Error;